<template>
  <div class="row pt-3">
    <div class="col-12">
      <div class="row">
        <div class="col-xl-3 col-lg-6">
          <div class="card">
            <div class="card-header">
              <slot name="header">
                <h2 class="card-title" title="Confirmed Cases">
                  Confirmed Cases
                </h2>
                <div class="card-category">
                  <span class="title-lg"
                    >{{ numberFormatter(confirmedCase) }} |&nbsp;</span
                  >
                  <div class="text-group">
                    <span class="text-primary title-sm">
                      <i class="fa fa-long-arrow-alt-up"></i>
                      {{ numberFormatter(confirmedCaseToday) }}
                    </span>
                    <small class="d-block">Change From Prior Day</small>
                  </div>
                </div>
              </slot>
            </div>
          </div>
        </div>
        <div class="col-xl-3 col-lg-6">
          <div class="card">
            <div class="card-header">
              <slot name="header">
                <h2 class="card-title" title="Currently Infected">
                  Currently Infected
                </h2>
                <div class="card-category">
                  <span class="title-lg"
                    >{{ numberFormatter(infected) }} |&nbsp;</span
                  >
                  <div class="text-group">
                    <span class="text-primary title-sm">
                      <i class="fa fa-long-arrow-alt-up"></i>
                      {{ numberFormatter(infectedToday) }}
                    </span>
                    <small class="d-block">Change From Prior Day</small>
                  </div>
                </div>
              </slot>
            </div>
          </div>
        </div>
        <div class="col-xl-3 col-lg-6">
          <div class="card">
            <div class="card-header">
              <slot name="header">
                <h2 class="card-title" title="Deaths">Deaths</h2>
                <div class="card-category">
                  <span class="title-lg"
                    >{{ numberFormatter(deaths) }} |&nbsp;</span
                  >
                  <div class="text-group">
                    <span class="text-primary title-sm">
                      <i class="fa fa-long-arrow-alt-up"></i>
                      {{ numberFormatter(deathsToday) }}
                    </span>
                    <small class="d-block">Change From Prior Day</small>
                  </div>
                </div>
              </slot>
            </div>
          </div>
        </div>
        <div class="col-xl-3 col-lg-6">
          <div class="card">
            <div class="card-header">
              <slot name="header">
                <h2 class="card-title" title="Vaccine Initiated">
                  Vaccine Initiated
                </h2>
                <div class="card-category">
                  <span class="title-lg"
                    >{{ numberFormatter(vaccinationsInitiated) }} |&nbsp;</span
                  >
                  <div class="text-group">
                    <span class="text-primary title-sm">
                      <i class="fa fa-long-arrow-alt-up"></i>
                      {{ numberFormatter(vaccinationsInitiatedToday) }}
                    </span>
                    <small class="d-block">Change From Prior Day</small>
                  </div>
                </div>
              </slot>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Confirmed Cases by USA charts -->
    <div class="col-lg-6" :class="{ 'text-right': isRTL }">
      <card type="chart">
        <template slot="header">
          <div class="row">
            <div class="col-sm-8" :class="isRTL ? 'text-right' : 'text-left'">
              <h2 class="card-title d-inline" title="Confirmed Cases">
                Confirmed Cases
              </h2>
              <el-tooltip
                content="Number of confirmed positive Covid-19 cases."
                effect="dark"
                :open-delay="300"
                placement="top"
              >
                <base-button type="link">
                  <i
                    class="fa fa-info-circle text-info fa-2x info-cursor pl-1 mb-2"
                  ></i>
                </base-button>
              </el-tooltip>
            </div>
            <div class="col-sm-4 d-flex d-sm-block">
              <div
                class="btn-group btn-group-toggle"
                :class="isRTL ? 'float-left' : 'float-right'"
                data-toggle="buttons"
              >
                <label
                  v-for="(option, index) in chartTypeOptionsTwo"
                  :key="option"
                  class="btn btn-sm btn-primary btn-simple"
                  :class="{ active: confirmedUSAChart.activeIndex === index }"
                  :id="index"
                >
                  <input
                    type="radio"
                    @click="renderConfirmedUSAChartData(index)"
                    name="options"
                    autocomplete="off"
                    :checked="confirmedUSAChart.activeIndex === index"
                  />
                  <span class="d-sm-block">{{ option }}</span>
                </label>
              </div>
            </div>
          </div>
        </template>
        <div class="chart-area">
          <line-chart
            style="height: 100%"
            :chart-data="confirmedUSAChart.chartData"
            :gradient-colors="confirmedUSAChart.gradientColors"
            :gradient-stops="confirmedUSAChart.gradientStops"
            :extra-options="confirmedUSAChart.extraOptions"
          ></line-chart>
        </div>
      </card>
    </div>
    <!-- Deaths by USA charts -->
    <div class="col-lg-6" :class="{ 'text-right': isRTL }">
      <card type="chart">
        <template slot="header">
          <div class="row">
            <div class="col-sm-8" :class="isRTL ? 'text-right' : 'text-left'">
              <h2 class="card-title d-inline" title="Deaths">Deaths</h2>
              <el-tooltip
                content="Number of deaths from Covid-19."
                effect="dark"
                :open-delay="300"
                placement="top"
              >
                <base-button type="link">
                  <i
                    class="fa fa-info-circle text-info fa-2x info-cursor pl-1 mb-2"
                  ></i>
                </base-button>
              </el-tooltip>
            </div>
            <div class="col-sm-4 d-flex d-sm-block">
              <div
                class="btn-group btn-group-toggle"
                :class="isRTL ? 'float-left' : 'float-right'"
                data-toggle="buttons"
              >
                <label
                  v-for="(option, index) in chartTypeOptionsTwo"
                  :key="option"
                  class="btn btn-sm btn-primary btn-simple"
                  :class="{ active: deathUSAChart.activeIndex === index }"
                  :id="index"
                >
                  <input
                    type="radio"
                    @click="renderDeathUSAChartData(index)"
                    name="options"
                    autocomplete="off"
                    :checked="confirmedUSAChart.activeIndex === index"
                  />
                  <span class="d-sm-block">{{ option }}</span>
                </label>
              </div>
            </div>
          </div>
        </template>
        <div class="chart-area">
          <line-chart
            style="height: 100%"
            :chart-data="deathUSAChart.chartData"
            :gradient-colors="deathUSAChart.gradientColors"
            :gradient-stops="deathUSAChart.gradientStops"
            :extra-options="deathUSAChart.extraOptions"
          ></line-chart>
        </div>
      </card>
    </div>
    <div class="col-lg-6">
      <map-chart-vaccin />
    </div>
    <!-- Confirmed Cases by State charts -->
    <div class="col-lg-6" :class="{ 'text-right': isRTL }">
      <card type="chart">
        <template slot="header">
          <div class="row">
            <div class="col-sm-8" :class="isRTL ? 'text-right' : 'text-left'">
              <h2 class="card-title d-inline" title="Confirmed Cases by State">
                Confirmed Cases by State
              </h2>
              <el-tooltip
                content="Number of confirmed positive Covid-19 cases by state."
                effect="dark"
                :open-delay="300"
                placement="top"
              >
                <base-button type="link">
                  <i
                    class="fa fa-info-circle text-info fa-2x info-cursor pl-1 mb-2"
                  ></i>
                </base-button>
              </el-tooltip>
            </div>
            <div class="col-sm-4 d-flex d-sm-block">
              <div
                class="btn-group btn-group-toggle"
                :class="isRTL ? 'float-left' : 'float-right'"
                data-toggle="buttons"
              >
                <label
                  v-for="(option, index) in chartTypeOptionsTwo"
                  :key="option"
                  class="btn btn-sm btn-primary btn-simple"
                  :class="{ active: positiveChart.activeIndex === index }"
                  :id="index"
                >
                  <input
                    type="radio"
                    @click="renderPositiveChartData(index)"
                    name="options"
                    autocomplete="off"
                    :checked="positiveChart.activeIndex === index"
                  />
                  <span class="d-sm-block">{{ option }}</span>
                </label>
              </div>
            </div>
          </div>
          <div class="row mt-1">
            <div class="col-lg-6" :class="{ 'text-right': isRTL }">
              <el-select
                multiple
                :collapse-tags="true"
                class="select-info"
                size="large"
                v-model="positiveStates"
                filterable
                placeholder="Select States"
                v-on:change="changePositiveSelect()"
              >
                <el-option
                  v-for="option in states"
                  class="select-info"
                  :value="option"
                  :label="option"
                  :key="option"
                ></el-option>
              </el-select>
            </div>
          </div>
        </template>
        <div class="chart-area">
          <line-chart
            style="height: 100%"
            :chart-data="positiveChart.chartData"
            :gradient-colors="positiveChart.gradientColors"
            :gradient-stops="positiveChart.gradientStops"
            :extra-options="positiveChart.extraOptions"
          ></line-chart>
        </div>
      </card>
    </div>
    <!--  Currently Infected by State chart -->
    <div class="col-lg-6" :class="{ 'text-right': isRTL }">
      <card type="chart">
        <template slot="header">
          <div class="row">
            <div class="col-sm-8" :class="isRTL ? 'text-right' : 'text-left'">
              <h2
                class="card-title d-inline"
                title="Currently Infected by State"
              >
                Currently Infected by State
              </h2>
              <el-tooltip
                content="Number of people currently infected with Covid-19 by state. These are individuals with confirmed cases and not yet recovered from the disease."
                effect="dark"
                :open-delay="300"
                placement="top"
              >
                <base-button type="link">
                  <i
                    class="fa fa-info-circle text-info fa-2x info-cursor pl-1 mb-2"
                  ></i>
                </base-button>
              </el-tooltip>
            </div>
            <div class="col-sm-4 d-flex d-sm-block">
              <div
                class="btn-group btn-group-toggle"
                :class="isRTL ? 'float-left' : 'float-right'"
                data-toggle="buttons"
              >
                <label
                  v-for="(option, index) in chartTypeOptionsOne"
                  :key="option"
                  class="btn btn-sm btn-primary btn-simple"
                  :class="{ active: infectedChart.activeIndex === index }"
                  :id="index"
                >
                  <input
                    type="radio"
                    @click="renderInfectedChartData(index)"
                    name="options"
                    autocomplete="off"
                    :checked="infectedChart.activeIndex === index"
                  />
                  <span class="d-sm-block">{{ option }}</span>
                </label>
              </div>
            </div>
          </div>
          <div class="row mt-1">
            <div class="col-lg-6" :class="{ 'text-right': isRTL }">
              <el-select
                multiple
                :collapse-tags="true"
                class="select-info"
                size="large"
                v-model="infectedStates"
                filterable
                placeholder="Select States"
                v-on:change="changeInfectedSelect()"
              >
                <el-option
                  v-for="option in states"
                  class="select-info"
                  :value="option"
                  :label="option"
                  :key="option"
                ></el-option>
              </el-select>
            </div>
          </div>
        </template>
        <div class="chart-area">
          <line-chart
            style="height: 100%"
            :chart-data="infectedChart.chartData"
            :gradient-colors="infectedChart.gradientColors"
            :gradient-stops="infectedChart.gradientStops"
            :extra-options="infectedChart.extraOptions"
          ></line-chart>
        </div>
      </card>
    </div>
    <!-- Recovered Cases by State chart -->
    <div class="col-lg-6" :class="{ 'text-right': isRTL }">
      <card type="chart">
        <template slot="header">
          <div class="row">
            <div class="col-sm-8" :class="isRTL ? 'text-right' : 'text-left'">
              <h2 class="card-title d-inline" title="Recovered Cases by State">
                Recovered Cases by State
              </h2>
              <el-tooltip
                content="Number of people infected with Covid-19 that have recovered from the disease."
                effect="dark"
                :open-delay="300"
                placement="top"
              >
                <base-button type="link">
                  <i
                    class="fa fa-info-circle text-info fa-2x info-cursor pl-1 mb-2"
                  ></i>
                </base-button>
              </el-tooltip>
            </div>
            <div class="col-sm-4 d-flex d-sm-block">
              <div
                class="btn-group btn-group-toggle"
                :class="isRTL ? 'float-left' : 'float-right'"
                data-toggle="buttons"
              >
                <label
                  v-for="(option, index) in chartTypeOptionsTwo"
                  :key="option"
                  class="btn btn-sm btn-primary btn-simple"
                  :class="{ active: recoveredChart.activeIndex === index }"
                  :id="index"
                >
                  <input
                    type="radio"
                    @click="renderRecoveredChartData(index)"
                    name="options"
                    autocomplete="off"
                    :checked="recoveredChart.activeIndex === index"
                  />
                  <span class="d-sm-block">{{ option }}</span>
                </label>
              </div>
            </div>
          </div>
          <div class="row mt-1">
            <div class="col-lg-6" :class="{ 'text-right': isRTL }">
              <el-select
                multiple
                :collapse-tags="true"
                class="select-info"
                size="large"
                v-model="recoveredStates"
                filterable
                placeholder="Select States"
                v-on:change="changeRecoveredSelect()"
              >
                <el-option
                  v-for="option in states"
                  class="select-info"
                  :value="option"
                  :label="option"
                  :key="option"
                ></el-option>
              </el-select>
            </div>
          </div>
        </template>
        <div class="chart-area">
          <line-chart
            style="height: 100%"
            :chart-data="recoveredChart.chartData"
            :gradient-colors="recoveredChart.gradientColors"
            :gradient-stops="recoveredChart.gradientStops"
            :extra-options="recoveredChart.extraOptions"
          ></line-chart>
        </div>
      </card>
    </div>
    <!-- Deaths by State chart -->
    <div class="col-lg-6" :class="{ 'text-right': isRTL }">
      <card type="chart">
        <template slot="header">
          <div class="row">
            <div class="col-sm-5" :class="isRTL ? 'text-right' : 'text-left'">
              <h2 class="card-title d-inline" title="Deaths by State">
                Deaths by State
              </h2>
              <el-tooltip
                content="Number of deaths from Covid-19 by state."
                effect="dark"
                :open-delay="300"
                placement="top"
              >
                <base-button type="link">
                  <i
                    class="fa fa-info-circle text-info fa-2x info-cursor pl-1 mb-2"
                  ></i>
                </base-button>
              </el-tooltip>
            </div>
            <div class="col-sm-7 d-flex d-sm-block">
              <div
                class="btn-group btn-group-toggle"
                :class="isRTL ? 'float-left' : 'float-right'"
                data-toggle="buttons"
              >
                <label
                  v-for="(option, index) in chartTypeOptionsDeaths"
                  :key="option"
                  class="btn btn-sm btn-primary btn-simple"
                  :class="{ active: deathChart.activeIndex === index }"
                  :id="index"
                >
                  <input
                    type="radio"
                    @click="renderDeathChartData(index)"
                    name="options"
                    autocomplete="off"
                    :checked="deathChart.activeIndex === index"
                  />
                  <span class="d-sm-block">{{ option }}</span>
                </label>
              </div>
            </div>
          </div>
          <div class="row mt-1">
            <div class="col-lg-6" :class="{ 'text-right': isRTL }">
              <el-select
                multiple
                :collapse-tags="true"
                class="select-info"
                size="large"
                v-model="deathStates"
                filterable
                placeholder="Select States"
                v-on:change="changeDeathSelect()"
              >
                <el-option
                  v-for="option in states"
                  class="select-info"
                  :value="option"
                  :label="option"
                  :key="option"
                ></el-option>
              </el-select>
            </div>
          </div>
        </template>
        <div class="chart-area">
          <line-chart
            style="height: 100%"
            :chart-data="deathChart.chartData"
            :gradient-colors="deathChart.gradientColors"
            :gradient-stops="deathChart.gradientStops"
            :extra-options="deathChart.extraOptions"
          ></line-chart>
        </div>
      </card>
    </div>
    <!-- Tests by State	chart -->
    <div class="col-lg-6" :class="{ 'text-right': isRTL }">
      <card type="chart">
        <template slot="header">
          <div class="row">
            <div class="col-sm-8" :class="isRTL ? 'text-right' : 'text-left'">
              <h2 class="card-title d-inline" title="Tests by State">
                Tests by State
              </h2>
              <el-tooltip
                content="Number of Covid-19 tests administered by state."
                effect="dark"
                :open-delay="300"
                placement="top"
              >
                <base-button type="link">
                  <i
                    class="fa fa-info-circle text-info fa-2x info-cursor pl-1 mb-2"
                  ></i>
                </base-button>
              </el-tooltip>
            </div>
            <div class="col-sm-4 d-flex d-sm-block">
              <div
                class="btn-group btn-group-toggle"
                :class="isRTL ? 'float-left' : 'float-right'"
                data-toggle="buttons"
              >
                <label
                  v-for="(option, index) in chartTypeOptionsFour"
                  :key="option"
                  class="btn btn-sm btn-primary btn-simple"
                  :class="{ active: totalChart.activeIndex === index }"
                  :id="index"
                >
                  <input
                    type="radio"
                    @click="renderTotalChartData(index)"
                    name="options"
                    autocomplete="off"
                    :checked="totalChart.activeIndex === index"
                  />
                  <span class="d-sm-block">{{ option }}</span>
                </label>
              </div>
            </div>
          </div>
          <div class="row mt-1">
            <div class="col-lg-6" :class="{ 'text-right': isRTL }">
              <el-select
                multiple
                :collapse-tags="true"
                class="select-info"
                size="large"
                v-model="totalStates"
                filterable
                placeholder="Select States"
                v-on:change="changeTotalSelect()"
              >
                <el-option
                  v-for="option in states"
                  class="select-info"
                  :value="option"
                  :label="option"
                  :key="option"
                ></el-option>
              </el-select>
            </div>
          </div>
        </template>
        <div class="chart-area">
          <line-chart
            style="height: 100%"
            :chart-data="totalChart.chartData"
            :gradient-colors="totalChart.gradientColors"
            :gradient-stops="totalChart.gradientStops"
            :extra-options="totalChart.extraOptions"
          ></line-chart>
        </div>
      </card>
    </div>
    <!-- Hospitalizations by State chart -->
    <div class="col-lg-6" :class="{ 'text-right': isRTL }">
      <card type="chart">
        <template slot="header">
          <div class="row">
            <div class="col-sm-8" :class="isRTL ? 'text-right' : 'text-left'">
              <h2 class="card-title d-inline" title="Hospitalizations by State">
                Hospitalizations by State
              </h2>
              <el-tooltip
                content="Number of people hospitalized with Covid-19 by state."
                effect="dark"
                :open-delay="300"
                placement="top"
              >
                <base-button type="link">
                  <i
                    class="fa fa-info-circle text-info fa-2x info-cursor pl-1 mb-2"
                  ></i>
                </base-button>
              </el-tooltip>
            </div>
            <div class="col-sm-4 d-flex d-sm-block">
              <div
                class="btn-group btn-group-toggle"
                :class="isRTL ? 'float-left' : 'float-right'"
                data-toggle="buttons"
              >
                <label
                  v-for="(option, index) in chartTypeOptionsThree"
                  :key="option"
                  class="btn btn-sm btn-primary btn-simple"
                  :class="{
                    active: hospitalizationChart.activeIndex === index,
                  }"
                  :id="index"
                >
                  <input
                    type="radio"
                    @click="renderHospitalizationChartData(index)"
                    name="options"
                    autocomplete="off"
                    :checked="hospitalizationChart.activeIndex === index"
                  />
                  <span class="d-sm-block">{{ option }}</span>
                </label>
              </div>
            </div>
          </div>
          <div class="row mt-1">
            <div class="col-lg-6" :class="{ 'text-right': isRTL }">
              <el-select
                multiple
                :collapse-tags="true"
                class="select-info"
                size="large"
                v-model="hospitalizationStates"
                filterable
                placeholder="Select States"
                v-on:change="changeHospitalizationSelect()"
              >
                <el-option
                  v-for="option in states"
                  class="select-info"
                  :value="option"
                  :label="option"
                  :key="option"
                ></el-option>
              </el-select>
            </div>
          </div>
        </template>
        <div class="chart-area">
          <line-chart
            style="height: 100%"
            :chart-data="hospitalizationChart.chartData"
            :gradient-colors="hospitalizationChart.gradientColors"
            :gradient-stops="hospitalizationChart.gradientStops"
            :extra-options="hospitalizationChart.extraOptions"
          ></line-chart>
        </div>
      </card>
    </div>
    <!-- Case Fatality by State  chart-->
    <div class="col-lg-6" :class="{ 'text-right': isRTL }">
      <card type="chart">
        <template slot="header">
          <div class="row">
            <div class="col-sm-8" :class="isRTL ? 'text-right' : 'text-left'">
              <h2 class="card-title d-inline" title="Case Fatality by State">
                Case Fatality by State
              </h2>
              <el-tooltip
                content="Case-Fatality Ratio (%) = Number recorded deaths / Number cases."
                effect="dark"
                :open-delay="300"
                placement="top"
              >
                <base-button type="link">
                  <i
                    class="fa fa-info-circle text-info fa-2x info-cursor pl-1 mb-2"
                  ></i>
                </base-button>
              </el-tooltip>
            </div>
          </div>
          <div class="row mt-1">
            <div class="col-lg-6" :class="{ 'text-right': isRTL }">
              <el-select
                multiple
                :collapse-tags="true"
                class="select-info"
                size="large"
                v-model="fatalityStates"
                filterable
                placeholder="Select States"
                v-on:change="changeFatalitySelect()"
              >
                <el-option
                  v-for="option in states"
                  class="select-info"
                  :value="option"
                  :label="option"
                  :key="option"
                ></el-option>
              </el-select>
            </div>
          </div>
        </template>
        <div class="chart-area">
          <line-chart
            style="height: 100%"
            :chart-data="fatalityChart.chartData"
            :gradient-colors="fatalityChart.gradientColors"
            :gradient-stops="fatalityChart.gradientStops"
            :extra-options="fatalityChart.extraOptions"
          ></line-chart>
        </div>
      </card>
    </div>
        <!-- Vaccinations by State charts -->
    <div class="col-lg-12" :class="{ 'text-right': isRTL }">
      <card type="chart">
        <template slot="header">
          <div class="row">
            <div class="col-sm-8" :class="isRTL ? 'text-right' : 'text-left'">
              <h2 class="card-title d-inline" title="Vaccinations by State">
                Vaccinations by State
              </h2>
              <el-tooltip
                content="Number of vaccinations initiated, distributed or completed by States."
                effect="dark"
                :open-delay="300"
                placement="top"
              >
                <base-button type="link">
                  <i
                    class="fa fa-info-circle text-info fa-2x info-cursor pl-1 mb-2"
                  ></i>
                </base-button>
              </el-tooltip>
            </div>
            <div class="col-sm-4 d-flex d-sm-block">
              <div
                class="btn-group btn-group-toggle"
                :class="isRTL ? 'float-left' : 'float-right'"
                data-toggle="buttons"
              >
                <label
                  v-for="(option, index) in chartTypeOptionsVaccin"
                  :key="option"
                  class="btn btn-sm btn-primary btn-simple"
                  :class="{ active: vaccinChart.activeIndex === index }"
                  :id="index"
                >
                  <input
                    type="radio"
                    @click="renderVaccinChartData(index)"
                    name="options"
                    autocomplete="off"
                    :checked="vaccinChart.activeIndex === index"
                  />
                  <span class="d-sm-block">{{ option }}</span>
                </label>
              </div>
            </div>
          </div>
          <div class="row mt-1">
            <div class="col-lg-6" :class="{ 'text-right': isRTL }">
              <el-select
                multiple
                :collapse-tags="true"
                class="select-info"
                size="large"
                v-model="vaccinStates"
                filterable
                placeholder="Select States"
                v-on:change="changeVaccinSelect()"
              >
                <el-option
                  v-for="option in states"
                  class="select-info"
                  :value="option"
                  :label="option"
                  :key="option"
                ></el-option>
              </el-select>
            </div>
          </div>
        </template>
        <div class="chart-area">
          <line-chart
            style="height: 100%"
            :chart-data="vaccinChart.chartData"
            :gradient-colors="vaccinChart.gradientColors"
            :gradient-stops="vaccinChart.gradientStops"
            :extra-options="vaccinChart.extraOptions"
          ></line-chart>
        </div>
      </card>
    </div>
    <!-- Rt vs New Cases by State chart -->
    <div class="col-lg-12" :class="{ 'text-right': isRTL }" id="rtchartbystate">
      <card type="chart">
        <template slot="header">
          <div class="row">
            <div class="col-sm-12" :class="isRTL ? 'text-right' : 'text-left'">
              <h2 class="card-title d-inline" title="Rt vs New Cases by State">
                Rt vs New Cases by State
              </h2>
              <el-tooltip
                content="Effective reproduction number (Rt) compared to number of new cases by state. This graph shows the association between Rt and new cases reported."
                effect="dark"
                :open-delay="300"
                placement="top"
              >
                <base-button type="link">
                  <i
                    class="fa fa-info-circle text-info fa-2x info-cursor pl-1 mb-2"
                  ></i>
                </base-button>
              </el-tooltip>
            </div>
          </div>
          <div class="row mt-1">
            <div class="col-lg-6" :class="{ 'text-right': isRTL }">
              <el-select
                class="select-info"
                size="large"
                v-model="rtStates"
                filterable
                placeholder="Select State"
                v-on:change="changeRtByStateSelect()"
              >
                <el-option
                  v-for="option in regions"
                  class="select-info"
                  :value="option"
                  :label="option"
                  :key="option"
                ></el-option>
              </el-select>
            </div>
          </div>
        </template>
        <div class="chart-area">
          <multi-line-chart
            style="height: 100%"
            :chart-data="rtChart.chartData"
            :gradient-colors="rtChart.gradientColors"
            :gradient-stops="rtChart.gradientStops"
            :extra-options="rtChart.extraOptions"
          ></multi-line-chart>
        </div>
      </card>
    </div>
    <!--  Effective Reproduction Number (Rt) by State chart-->
    <div class="col-lg-12" :class="{ 'text-right': isRTL }">
      <card type="chart">
        <template slot="header">
          <div class="row">
            <div class="col-sm-6" :class="isRTL ? 'text-right' : 'text-left'">
              <h2
                class="card-title d-inline"
                title="Effective Reproduction Number (Rt) by State"
              >
                Effective Reproduction Number (Rt) by State
              </h2>
              <el-tooltip
                content="Effective reproduction number (Rt) shown across all states. Rt is a measure of how fast the virus is growing. Red shows an Rt value of 1 or greater indicating that the rate of transmission is increasing for each new Covid-19 case. Green shows an Rt value of 0.99 or less and indicates that the virus will stop spreading."
                effect="dark"
                :open-delay="300"
                placement="top"
              >
                <base-button type="link">
                  <i
                    class="fa fa-info-circle text-info fa-2x info-cursor pl-1 mb-2"
                  ></i>
                </base-button>
              </el-tooltip>
            </div>
            <div class="col-sm-6 d-flex d-sm-block">
              <div
                class="btn-group btn-group-toggle"
                :class="isRTL ? 'float-left' : 'float-right'"
                data-toggle="buttons"
              >
                <label
                  v-for="(option, index) in chartTypeOptionsWeek"
                  :key="option"
                  class="btn btn-sm btn-primary btn-simple"
                  :class="{ active: rtBarChart.activeIndex === index }"
                  :id="index"
                >
                  <input
                    type="radio"
                    @click="renderRTChart(index)"
                    name="options"
                    autocomplete="off"
                    :checked="rtBarChart.activeIndex === index"
                  />
                  <span class="d-sm-block">{{ option }}</span>
                </label>
              </div>
            </div>
          </div>
        </template>
        <div class="chart-area">
          <div id="chartjs-tooltip">
            <table></table>
          </div>
          <div class="chartWrapper" v-if="isMobile">
            <bar-chart
              :width="1200"
              style="height: 100%; overflow-x: scroll"
              :chart-data="rtBarChart.chartData"
              :gradient-stops="rtBarChart.gradientStops"
              :extra-options="rtBarChart.extraOptions"
            ></bar-chart>
          </div>
          <bar-chart
            v-else
            style="height: 100%"
            :chart-data="rtBarChart.chartData"
            :gradient-stops="rtBarChart.gradientStops"
            :extra-options="rtBarChart.extraOptions"
          ></bar-chart>
          <ul class="legend mt-2">
            <li><span class="fifty"></span> 50%</li>
            <li><span class="ninety"></span> 90%</li>
            <li><small class="pl-3"></small> Confidence Interval</li>
          </ul>
        </div>
        <div slot="footer">
          <small class="text-white"
            >While we make a best effort to accurately present Rt values by
            state, every model has variance in</small
          >
          <br />
          <small class="text-white">
            approach. Please calibrate against other Rt models including:
            <a href="https://rt.live/" target="_blank">rt.live</a>,
            <a
              href="https://epiforecasts.io/covid/posts/national/united-states/"
              target="_blank"
              >epiforecasts.io</a
            >, and others.
          </small>
        </div>
      </card>
    </div>
    <div class="col-lg-12">
      <map-chart />
    </div>
    <div class="col-lg-12" :class="{ 'text-right': isRTL }">
      <economic-chart />
    </div>
  </div>
</template>
<script>
import LineChart from "@/components/Charts/LineChart";
import MultiLineChart from "@/components/Charts/MultiLineChart";
import BarChart from "@/components/Charts/BarChart";
import MapChart from "@/pages/Dashboard/MapChart";
import MapChartVaccin from "@/pages/Dashboard/MapChartVaccin";
import EconomicChart from "@/pages/Dashboard/EconomicChart";
import * as chartConfigs from "@/components/Charts/config";
import config from "@/config";
import axios from "axios";
import lodash from "lodash";
import moment from "moment";
import { Select, Option } from "element-ui";
const options = chartConfigs.lineChartOptions;
const optionsTop = chartConfigs.lineChartTopOptions;
const removeState = chartConfigs.removeState;
export default {
  components: {
    LineChart,
    MultiLineChart,
    BarChart,
    [Option.name]: Option,
    [Select.name]: Select,
    MapChart,
    EconomicChart,
    MapChartVaccin,
  },
  data() {
    return {
      rtPullDate: "",
      rtPullTime: "",
      jhuPullDate: "",
      jhuPullTime: "",
      confirmedCase: "...",
      confirmedCaseToday: "...",
      infected: "...",
      infectedToday: "...",
      deaths: "...",
      deathsToday: "...",
      recovered: "...",
      recoveredToday: "...",
      vaccinationsInitiated: "...",
      vaccinationsInitiatedToday: "...",
      chartTypeOptionsZero: ["Total", "Logarithmic"],
      chartTypeOptionsOne: ["Total", "Logarithmic"],
      chartTypeOptionsTwo: ["Total", "Logarithmic", "Daily"],
      chartTypeOptionsThree: ["Total", "Logarithmic", "Current"],
      chartTypeOptionsFour: ["Total", "Logarithmic", "Rate"],
      chartTypeOptionsVaccin: ["Distributed", "Initiated", "Completed"],
      chartTypeOptionsDeaths: [
        "Total",
        "Logarithmic",
        "Daily",
        "Mortality Rate",
      ],
      chartTypeOptionsWeek: [
        "Latest",
        "Last Week",
        "2 Weeks Ago",
        "4 Weeks Ago",
        "6 Weeks Ago",
      ],
      dateFormat: "MMM D, YYYY",
      showTop: 5,
      chartCommonOption: {
        fill: true,
        lineTension: 0,
        borderWidth: 2,
        borderDash: [],
        borderDashOffset: 0.0,
        pointBorderColor: "rgba(255,255,255,0)",
        pointBorderWidth: 20,
        pointHoverRadius: 5,
        pointHoverBorderWidth: 15,
        pointHitRadius: 5,
        pointRadius: 0,
      },
      originalJHUData: [],
      originalActData: [],
      originalVaccinData: [],
      states: [],
      regions: [],
      positiveStates: [],
      positiveChart: {
        activeIndex: 0,
        extraOptions: {},
        chartData: {
          labels: [],
          datasets: [],
        },
        gradientColors: config.colors.primaryGradient,
        gradientStops: [1, 0.2, 0],
      },
      deathStates: [],
      deathChart: {
        activeIndex: 0,
        extraOptions: {},
        chartData: {
          labels: [],
          datasets: [],
        },
        gradientColors: config.colors.primaryGradient,
        gradientStops: [1, 0.2, 0],
      },
      hospitalizationStates: [],
      hospitalizationChart: {
        activeIndex: 0,
        extraOptions: {},
        chartData: {
          labels: [],
          datasets: [],
        },
        gradientColors: config.colors.primaryGradient,
        gradientStops: [1, 0.2, 0],
      },
      fatalityStates: [],
      fatalityChart: {
        activeIndex: 0,
        extraOptions: {},
        chartData: {
          labels: [],
          datasets: [],
        },
        gradientColors: config.colors.primaryGradient,
        gradientStops: [1, 0.2, 0],
      },
      negativeStates: [],
      negativeChart: {
        activeIndex: 0,
        extraOptions: {},
        chartData: {
          labels: [],
          datasets: [],
        },
        gradientColors: config.colors.primaryGradient,
        gradientStops: [1, 0.2, 0],
      },
      recoveredStates: [],
      recoveredChart: {
        activeIndex: 0,
        extraOptions: {},
        chartData: {
          labels: [],
          datasets: [],
        },
        gradientColors: config.colors.primaryGradient,
        gradientStops: [1, 0.2, 0],
      },
      totalStates: [],
      totalChart: {
        activeIndex: 0,
        extraOptions: {},
        chartData: {
          labels: [],
          datasets: [],
        },
        gradientColors: config.colors.primaryGradient,
        gradientStops: [1, 0.2, 0],
      },
      infectedStates: [],
      infectedChart: {
        activeIndex: 0,
        extraOptions: {},
        chartData: {
          labels: [],
          datasets: [],
        },
        gradientColors: config.colors.primaryGradient,
        gradientStops: [1, 0.2, 0],
      },
      rtStates: "",
      rtChart: {
        activeIndex: 0,
        extraOptions: {},
        chartData: {
          labels: [],
          datasets: [],
        },
        gradientColors: config.colors.primaryGradient,
        gradientStops: [1, 0.2, 0],
      },
      rtBarChart: {
        activeIndex: 0,
        extraOptions: {},
        chartData: {
          labels: [],
          datasets: [],
        },
        gradientColors: config.colors.primaryGradient,
        gradientStops: [1, 0.4, 0],
      },
      originalRTData: [],
      originalDashData: [],
      confirmedUSAChart: {
        activeIndex: 0,
        extraOptions: {},
        chartData: {
          labels: [],
          datasets: [],
        },
        gradientColors: config.colors.primaryGradient,
        gradientStops: [1, 0.2, 0],
      },
      deathUSAChart: {
        activeIndex: 0,
        extraOptions: {},
        chartData: {
          labels: [],
          datasets: [],
        },
        gradientColors: config.colors.primaryGradient,
        gradientStops: [1, 0.2, 0],
      },
      vaccinStates: [],
      vaccinChart: {
        activeIndex: 0,
        extraOptions: {},
        chartData: {
          labels: [],
          datasets: [],
        },
        gradientColors: config.colors.primaryGradient,
        gradientStops: [1, 0.2, 0],
      },
    };
  },
  computed: {
    isMobile() {
      this.renderRTChart;
      if (this.$screen.breakpoint === "lg" || this.$screen.breakpoint === "xl")
        return false;

      return true;
    },
    enableRTL() {
      return this.$route.query.enableRTL;
    },
    isRTL() {
      return this.$rtl.isRTL;
    },
  },
  methods: {
    chartOption(labelString, index = 0) {
      var extraoption = {
        display: true,
        scaleLabel: {
          display: true,
          labelString: labelString,
        },
      };
      if (index === 1) {
        return [
          {
            type: "logarithmic",
            ...extraoption,
            ticks: {
              beginAtZero: true,
              min: 0,
              max: 100000000,
              callback: function (value, index, values) {
                if (value === 100000000) return "100M";
                if (value === 10000000) return "10M";
                if (value === 10000000) return "10M";
                if (value === 1000000) return "1M";
                if (value === 100000) return "100K";
                if (value === 10000) return "10K";
                if (value === 1000) return "1K";
                if (value === 100) return "100";
                if (value === 10) return "10";
                if (value === 0) return "0";
                return null;
              },
            },
          },
        ];
      }
      return [
        {
          ...extraoption,
          ticks: {
            beginAtZero: true,
            callback: function (value, index, values) {
              return value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
            },
          },
        },
      ];
    },
    getChartDataSet(dataset, filterdata, key, chartType = 0, graphDate) {
      var self = this;
      var dates = self.getAllDates([...graphDate]);
      var allDate = [...new Set(dates)];
      var groupStateData = lodash.groupBy(filterdata, "state");
      Object.keys(groupStateData).forEach(function (stateKey, index) {
        var allData = self.generateChartPointData(
          groupStateData[stateKey],
          allDate,
          key
        );
        var hidden = false;
        //REVIEW WHY THIS NEEDED commented out
        /*  if (chartType === 2 && key != "vaccinations_completed") {
          hidden = allData[allData.length - 1].y === 0 ? true : false;
        } */
        dataset.push({
          hidden: hidden,
          ...self.chartCommonOption,
          label: stateKey,
          pointBackgroundColor:
            chartConfigs.colorOptions.color[stateKey.trim()],
          borderColor: chartConfigs.colorOptions.color[stateKey.trim()],
          pointHoverBackgroundColor:
            chartConfigs.colorOptions.color[stateKey.trim()],
          data: allData,
        });
      });
    },
    generateChartPointData(groupStateData, allDate, key) {
      var self = this;
      var filterdata = [];
      allDate.forEach(function (element) {
        var data = groupStateData.find(function (el) {
          return el.date === element;
        });
        if (typeof data !== "undefined") {
          var obj = {
            x: moment.utc(element).format(self.dateFormat),
            y: 0,
          };
          if (data) {
            obj.x = moment.utc(data.date).format(self.dateFormat);
            obj.y =
              data[key] !== null
                ? data[key] === +data[key] && data[key] !== (data[key] | 0)
                  ? data[key].toFixed(2)
                  : data[key]
                : 0;
          }
          filterdata.push(obj);
        }
      });
      return filterdata;
    },
    getChartDataSetTop(
      dataset,
      filterdata,
      key,
      chartType = 0,
      graphDate,
      color
    ) {
      var self = this;
      var dates = self.getAllDates([...graphDate]);
      var allDate = [...new Set(dates)];
      var allData = self.generateChartPointData(filterdata, allDate, key);
      var hidden = false;
      if (chartType === 2) {
        hidden = allData[allData.length - 1].y === 0 ? true : false;
      }
      dataset.push({
        hidden: hidden,
        ...self.chartCommonOption,
        label: "",
        pointBackgroundColor: color,
        borderColor: color,
        pointHoverBackgroundColor: color,
        data: allData,
      });
    },
    getAllDates(date) {
      return [...date]
        .sort(function (a, b) {
          return new Date(a.date) - new Date(b.date);
        })
        .map((d) => d.date);
    },
    changePositiveSelect() {
      this.renderPositiveChartData(this.positiveChart.activeIndex);
    },
    renderPositiveChartData(index) {
      var self = this;
      self.positiveChart.activeIndex = index;
      self.positiveChart.chartData.labels = [];
      self.positiveChart.chartData.datasets = [];
      self.positiveChart.extraOptions = {};
      self.positiveChart.extraOptions = lodash.cloneDeep(options);
      self.positiveChart.extraOptions.scales.yAxes = self.chartOption(
        "Positive Tests",
        index
      );
      var key = "confirmed";
      if (index === 2) {
        key = "confirmed_daily";
      }
      var filterdata = [...self.originalJHUData]
        .filter(function (item) {
          return self.positiveStates.includes(item.state);
        })
        .sort(function (a, b) {
          return (
            self.positiveStates.indexOf(a.state) -
            self.positiveStates.indexOf(b.state)
          );
        });
      self.getChartDataSet(
        self.positiveChart.chartData.datasets,
        filterdata,
        key,
        index,
        [...self.originalJHUData]
      );
    },
    changeDeathSelect() {
      this.renderDeathChartData(this.deathChart.activeIndex);
    },
    renderDeathChartData(index) {
      var self = this;
      this.deathChart.activeIndex = index;
      self.deathChart.chartData.labels = [];
      self.deathChart.chartData.datasets = [];
      self.deathChart.extraOptions = {};
      self.deathChart.extraOptions = lodash.cloneDeep(options);
      var key = "deaths";
      var lable = "Deaths";
      if (index === 2) {
        key = "deaths_daily";
      } else if (index === 3) {
        key = "mortality_rate";
        lable = "Mortality Rate";
      }
      self.deathChart.extraOptions.scales.yAxes = self.chartOption(
        lable,
        index
      );
      var filterdata = [...self.originalJHUData]
        .filter(function (item) {
          return self.deathStates.includes(item.state);
        })
        .sort(function (a, b) {
          return (
            self.deathStates.indexOf(a.state) -
            self.deathStates.indexOf(b.state)
          );
        });
      self.getChartDataSet(
        self.deathChart.chartData.datasets,
        filterdata,
        key,
        index,
        [...self.originalJHUData]
      );
    },
    changeHospitalizationSelect() {
      this.renderHospitalizationChartData(
        this.hospitalizationChart.activeIndex
      );
    },
    renderHospitalizationChartData(index) {
      var self = this;
      self.hospitalizationChart.activeIndex = index;
      self.hospitalizationChart.chartData.labels = [];
      self.hospitalizationChart.chartData.datasets = [];
      self.hospitalizationChart.extraOptions = {};
      self.hospitalizationChart.extraOptions = lodash.cloneDeep(options);
      var lable = "Hospitalizations";
      var key = "people_hospitalized";
      if (index === 2) {
        key = "hospitalization_rate";
        lable = "Hospitalization Rate";
      }
      self.hospitalizationChart.extraOptions.scales.yAxes = self.chartOption(
        lable,
        index
      );
      var filterdata = [...self.originalJHUData]
        .filter(function (item) {
          return self.hospitalizationStates.includes(item.state);
        })
        .sort(function (a, b) {
          return (
            self.hospitalizationStates.indexOf(a.state) -
            self.hospitalizationStates.indexOf(b.state)
          );
        });

      self.getChartDataSet(
        self.hospitalizationChart.chartData.datasets,
        filterdata,
        key,
        index,
        [...self.originalJHUData]
      );
    },
    changeNegativeSelect() {
      this.renderNegativeChartData(this.negativeChart.activeIndex);
    },
    renderNegativeChartData(index) {
      var self = this;
      self.negativeChart.activeIndex = index;
      self.negativeChart.chartData.labels = [];
      self.negativeChart.chartData.datasets = [];
      self.negativeChart.extraOptions = {};
      self.negativeChart.extraOptions = lodash.cloneDeep(options);
      self.negativeChart.extraOptions.scales.yAxes = self.chartOption(
        "Negative Tests",
        index
      );
      var key = "negative_tests";
      var filterdata = [...self.originalActData]
        .filter(function (item) {
          return self.negativeStates.includes(item.state);
        })
        .sort(function (a, b) {
          return (
            self.negativeStates.indexOf(a.state) -
            self.negativeStates.indexOf(b.state)
          );
        });
      self.getChartDataSet(
        self.negativeChart.chartData.datasets,
        filterdata,
        key,
        index,
        [...self.originalActData]
      );
    },
    changeFatalitySelect() {
      this.renderFatalityChartData(this.fatalityChart.activeIndex);
    },
    renderFatalityChartData(index) {
      var self = this;
      self.fatalityChart.activeIndex = index;
      self.fatalityChart.chartData.labels = [];
      self.fatalityChart.chartData.datasets = [];
      self.fatalityChart.extraOptions = {};
      self.fatalityChart.extraOptions = lodash.cloneDeep(options);
      self.fatalityChart.extraOptions.scales.yAxes = self.chartOption(
        "Fatality Ratio",
        index
      );
      var key = "case_fatality_ratio";
      var filterdata = [...self.originalJHUData]
        .filter(function (item) {
          return self.fatalityStates.includes(item.state);
        })
        .sort(function (a, b) {
          return (
            self.fatalityStates.indexOf(a.state) -
            self.fatalityStates.indexOf(b.state)
          );
        });
      self.getChartDataSet(
        self.fatalityChart.chartData.datasets,
        filterdata,
        key,
        index,
        [...self.originalJHUData]
      );
    },
    changeRecoveredSelect() {
      this.renderRecoveredChartData(this.recoveredChart.activeIndex);
    },
    renderRecoveredChartData(index) {
      var self = this;
      self.recoveredChart.activeIndex = index;
      self.recoveredChart.chartData.labels = [];
      self.recoveredChart.chartData.datasets = [];
      self.recoveredChart.extraOptions = {};
      self.recoveredChart.extraOptions = lodash.cloneDeep(options);
      self.recoveredChart.extraOptions.scales.yAxes = self.chartOption(
        "Recovered",
        index
      );
      var key = "recovered";
      if (index === 2) {
        key = "recovered_daily";
      }
      var filterdata = [...self.originalJHUData]
        .filter(function (item) {
          return self.recoveredStates.includes(item.state);
        })
        .sort(function (a, b) {
          return (
            self.recoveredStates.indexOf(a.state) -
            self.recoveredStates.indexOf(b.state)
          );
        });
      self.getChartDataSet(
        self.recoveredChart.chartData.datasets,
        filterdata,
        key,
        index,
        [...self.originalJHUData]
      );
    },
    changeTotalSelect() {
      this.renderTotalChartData(this.totalChart.activeIndex);
    },
    renderTotalChartData(index) {
      var self = this;
      var lable = "Total Tests";
      var key = "people_tested";
      if (index === 2) {
        key = "testing_rate";
        lable = "Rate";
      }
      self.totalChart.activeIndex = index;
      self.totalChart.chartData.labels = [];
      self.totalChart.chartData.datasets = [];
      self.totalChart.extraOptions = {};
      self.totalChart.extraOptions = lodash.cloneDeep(options);
      self.totalChart.extraOptions.scales.yAxes = self.chartOption(
        lable,
        index
      );

      var filterdata = [...self.originalJHUData]
        .filter(function (item) {
          return self.totalStates.includes(item.state);
        })
        .sort(function (a, b) {
          return (
            self.totalStates.indexOf(a.state) -
            self.totalStates.indexOf(b.state)
          );
        });
      self.getChartDataSet(
        self.totalChart.chartData.datasets,
        filterdata,
        key,
        index,
        [...self.originalJHUData]
      );
    },
    changeInfectedSelect() {
      this.renderInfectedChartData(this.infectedChart.activeIndex);
    },
    renderInfectedChartData(index) {
      var self = this;
      self.infectedChart.activeIndex = index;
      self.infectedChart.chartData.labels = [];
      self.infectedChart.chartData.datasets = [];
      self.infectedChart.extraOptions = {};
      self.infectedChart.extraOptions = lodash.cloneDeep(options);
      self.infectedChart.extraOptions.scales.yAxes = self.chartOption(
        "Currenlty Infected",
        index
      );
      var filterdata = [...self.originalJHUData]
        .filter(function (item) {
          return self.infectedStates.includes(item.state);
        })
        .sort(function (a, b) {
          return (
            self.infectedStates.indexOf(a.state) -
            self.infectedStates.indexOf(b.state)
          );
        });
      self.getChartDataSet(
        self.infectedChart.chartData.datasets,
        filterdata,
        "active",
        index,
        [...self.originalJHUData]
      );
    },
    generateVaccinChart() {
      var self = this;
      axios
        .get(process.env.VUE_APP_API_URL + "/covidactnow/vaccine")
        .then((response) => {
          var vaccin = response.data
            .filter(
              (value) =>
                !removeState.includes(value.state.trim()) &&
                value.vaccines_distributed !== null
            )
            .map((o) => {
              o.state = o.state.trim();
              return o;
            });
          //=================
          var groupByStateData = lodash.groupBy(vaccin, "state");
          self.states = Object.keys(groupByStateData).sort();
          var lastItem = [];
          self.originalVaccinData = [...vaccin].filter(function (element) {
            return new Date(element.date) >= new Date("2021-01-01");
          });
          Object.keys(groupByStateData).forEach(function (stateKey, index) {
            lastItem.push([...groupByStateData[stateKey]].pop());
          });

          self.vaccinStates = [...lastItem]
            .sort(
              (key1, key2) =>
                key2.vaccines_distributed - key1.vaccines_distributed
            )
            .slice(0, self.showTop)
            .map((x) => x.state);
          self.renderVaccinChartData(0);
        });
    },
    generateCovidActNowChart() {
      var self = this;
      axios
        .get(process.env.VUE_APP_API_URL + "/covidactnow")
        .then((response) => {
          var act = response.data
            .filter((value) => !removeState.includes(value.state.trim()))
            .map((o) => {
              o.state = o.state.trim();
              return o;
            });
          //=================
          var groupByStateData = lodash.groupBy(act, "state");
          self.states = Object.keys(groupByStateData).sort();
          var lastItem = [];
          self.originalActData = [...act].filter(function (element) {
            return new Date(element.date) >= new Date("2020-03-09");
          });
          Object.keys(groupByStateData).forEach(function (stateKey, index) {
            lastItem.push([...groupByStateData[stateKey]].pop());
          });
 
          self.negativeStates = [...lastItem]
            .sort((key1, key2) => key2.negative - key1.negative)
            .slice(0, self.showTop)
            .map((x) => x.state); 

          self.renderNegativeChartData(0); //covidactnow TODO change
        });
    },
    generateJHUChart() {
      var self = this;
      axios.get(process.env.VUE_APP_API_URL + "/jhu").then((response) => {
        var jhu = response.data
          .filter((value) => !removeState.includes(value.state.trim()))
          .map((o) => {
            o.state = o.state.trim();
            return o;
          });
        //update datasource pull data time
        self.jhuPullDate = moment.utc(jhu[0].updated).local().format("M/D");
        self.jhuPullTime = moment.utc(jhu[0].updated).local().format("h:mm A");
        $("#jhuDate").empty().append(self.jhuPullDate);
        $("#jhuTime").empty().append(self.jhuPullTime);
        //=============
        var groupByStateData = lodash.groupBy(jhu, "state");
        self.states = Object.keys(groupByStateData).sort();
        // console.log("State JHU=" + self.states.length, self.states);
        var lastItem = [];
        self.originalJHUData = [...jhu].filter(function (element) {
          return new Date(element.date) >= new Date("2020-03-09");
        });

        Object.keys(groupByStateData).forEach(function (stateKey, index) {
          lastItem.push([...groupByStateData[stateKey]].pop());
        });

        self.deathStates = [...lastItem]
          .sort((key1, key2) => key2.deaths - key1.deaths)
          .slice(0, self.showTop)
          .map((x) => x.state);

        self.infectedStates = [...lastItem]
          .sort((key1, key2) => key2.active - key1.active)
          .slice(0, self.showTop)
          .map((x) => x.state);

        self.hospitalizationStates = [...lastItem]
          .sort(
            (key1, key2) => key2.people_hospitalized - key1.people_hospitalized
          )
          .slice(0, self.showTop)
          .map((x) => x.state);

        self.totalStates = [...lastItem]
          .sort((key1, key2) => key2.people_tested - key1.people_tested)
          .slice(0, self.showTop)
          .map((x) => x.state);

        self.positiveStates = [...lastItem]
          .sort((key1, key2) => key2.confirmed - key1.confirmed)
          .slice(0, self.showTop)
          .map((x) => x.state);
        self.recoveredStates = [...lastItem]
          .sort((key1, key2) => key2.recovered - key1.recovered)
          .slice(0, self.showTop)
          .map((x) => x.state);
        self.fatalityStates = [...lastItem]
          .sort((key1, key2) => key2.case_fatality_ratio - key1.case_fatality_ratio)
          .slice(0, self.showTop)
          .map((x) => x.state);

        self.rtStates = self.positiveStates[0].trim();
        self.renderPositiveChartData(0);
        self.renderTotalChartData(0);
        self.renderDeathChartData(0);
        self.renderHospitalizationChartData(0);
        self.renderInfectedChartData(0);
        self.renderRtByStateChartData();
        self.renderRecoveredChartData(0);
        self.renderFatalityChartData(0);
      });
    },
    getDashData() {
      var self = this;
      axios.get(process.env.VUE_APP_API_URL + "/dash").then((response) => {
        var dashData = response.data;
        self.originalDashData = [...dashData].filter(function (element) {
          return new Date(element.date) >= new Date("2020-03-09");
        });
        var datalength = dashData.length;
        var currentData = dashData[datalength - 1];
        var previousData = dashData[datalength - 2];
        var previousDataMore = dashData[datalength - 3];
        self.confirmedCase = currentData.confirmed;
        self.confirmedCaseToday =
          currentData.confirmed - previousData.confirmed;
        self.infected = currentData.active;
        self.infectedToday = currentData.active - previousData.active;
        self.deaths = currentData.deaths;
        self.deathsToday = currentData.deaths - previousData.deaths;
        self.recovered = currentData.recovered;
        self.recoveredToday = currentData.recovered - previousData.recovered;
        var vaccin = parseInt(currentData.vaccinations_initiated_total);
        if (vaccin === 0) {
          self.vaccinationsInitiated = parseInt(
            previousData.vaccinations_initiated_total
          );
          self.vaccinationsInitiatedToday =
            previousData.vaccinations_initiated_total -
            previousDataMore.vaccinations_initiated_total;
          self.renderConfirmedUSAChartData(0);
          self.renderDeathUSAChartData(0);
        } else {
          self.vaccinationsInitiated = parseInt(
            currentData.vaccinations_initiated_total
          );
          self.vaccinationsInitiatedToday =
            currentData.vaccinations_initiated_total -
            previousData.vaccinations_initiated_total;
          self.renderConfirmedUSAChartData(0);
          self.renderDeathUSAChartData(0);
        }
      });
    },
    renderConfirmedUSAChartData(index) {
      var self = this;
      self.confirmedUSAChart.activeIndex = index;
      self.confirmedUSAChart.chartData.labels = [];
      self.confirmedUSAChart.chartData.datasets = [];
      self.confirmedUSAChart.extraOptions = {};
      self.confirmedUSAChart.extraOptions = lodash.cloneDeep(optionsTop);
      self.confirmedUSAChart.extraOptions.scales.yAxes = self.chartOption(
        "Confirmed Cases",
        index
      );
      var key = "confirmed";
      if (index === 2) {
        key = "confirmed_daily";
      }
      var filterdata = [...self.originalDashData];
      self.getChartDataSetTop(
        self.confirmedUSAChart.chartData.datasets,
        filterdata,
        key,
        index,
        [...self.originalDashData],
        "#33B0FF"
      );
    },
    renderDeathUSAChartData(index) {
      var self = this;
      self.deathUSAChart.activeIndex = index;
      self.deathUSAChart.chartData.labels = [];
      self.deathUSAChart.chartData.datasets = [];
      self.deathUSAChart.extraOptions = {};
      self.deathUSAChart.extraOptions = lodash.cloneDeep(optionsTop);
      self.deathUSAChart.extraOptions.scales.yAxes = self.chartOption(
        "Deaths",
        index
      );
      var key = "deaths";
      if (index === 2) {
        key = "deaths_daily";
      }
      var filterdata = [...self.originalDashData];
      self.getChartDataSetTop(
        self.deathUSAChart.chartData.datasets,
        filterdata,
        key,
        index,
        [...self.originalDashData],
        "#62DBBB"
      );
    },
    getBubbleData(sortData) {
      var bubbleData = [];
      sortData.forEach(function (element) {
        var label = chartConfigs.states_hash[element.state.trim()];
        var obj = {
          x: element.region,
          y: element.median.toFixed(2),
          r: 10,
          label: label,
        };
        bubbleData.push(obj);
      });
      return bubbleData;
    },
    generateRTChart() {
      var self = this;
      axios.get(process.env.VUE_APP_API_URL + "/rt").then((response) => {
        var rt = response.data
          .filter((value) => !removeState.includes(value.state.trim()))
          .map((o) => {
            o.state = o.state.trim();
            return o;
          });
        //update datasource pull data time
        self.rtPullDate = moment.utc(rt[0].updated).local().format("M/D");
        self.rtPullTime = moment.utc(rt[0].updated).local().format("h:mm A");
        //=============
        var groupByStateData = lodash.groupBy(rt, "state");
        self.regions = Object.keys(groupByStateData).sort();
        //console.log("State Rt=" + self.regions.length, self.regions);
        self.originalRTData = [...rt];
        self.renderRTChart(0);
        self.renderRtByStateChartData();
      });
    },
    scrollpage() {
      var tooltipEl = document.getElementById("chartjs-tooltip");
      tooltipEl.style.opacity = 0;
    },
    renderRTChart(index) {
      var self = this;
      self.rtBarChart.activeIndex = index;
      self.rtBarChart.chartData.labels = [];
      self.rtBarChart.chartData.datasets = [];
      self.rtBarChart.extraOptions = {};
      if (this.isMobile) {
        self.rtBarChart.extraOptions = {
          ...chartConfigs.barChartOptions,
          responsive: false,
          maintainAspectRatio: false,
          onClick: function (event, chartElement) {
            if (chartElement[0]) {
              const data =
                chartElement[0]._chart.config.data.datasets[0].data[
                  chartElement[0]._index
                ];
              // console.log(chartElement[0], data.x);
              var element = document.getElementById("rtchartbystate");
              var top = element.offsetTop;
              window.scrollTo(0, top);
              self.rtStates = data.x.trim();
              self.renderRtByStateChartData();
            }
          },
        };
      } else {
        self.rtBarChart.extraOptions = {
          ...chartConfigs.barChartOptions,
          responsive: true,
          maintainAspectRatio: false,
          onClick: function (event, chartElement) {
            if (chartElement[0]) {
              const data =
                chartElement[0]._chart.config.data.datasets[0].data[
                  chartElement[0]._index
                ];
              //  console.log(chartElement[0], data.x);
              var element = document.getElementById("rtchartbystate");
              var top = element.offsetTop;
              window.scrollTo(0, top);
              self.rtStates = data.x.trim();
              self.renderRtByStateChartData();
            }
          },
        };
      }

      var rt1 = [...self.originalRTData];
      var groupByStateData1 = lodash.groupBy(rt1, "state");
      var lastItem1 = [];
      Object.keys(groupByStateData1).forEach(function (stateKey, index) {
        lastItem1.push([...groupByStateData1[stateKey]].pop());
      });
      var sortData1 = lastItem1.sort((key1, key2) => key1.median - key2.median);

      var rt = [...self.originalRTData];
      var week = 1;
      if (index === 2) {
        week = 2;
      } else if (index === 3) {
        week = 4;
      } else if (index === 4) {
        week = 6;
      }
      if (index > 0) {
        rt = [];
        rt = [...self.originalRTData].filter(function (element) {
          return (
            new Date(element.date) <=
            new Date(moment().subtract(week, "week").format())
          );
        });
      }
      var groupByStateData = lodash.groupBy(rt, "state");
      var lastItem = [];
      Object.keys(groupByStateData).forEach(function (stateKey, index) {
        lastItem.push([...groupByStateData[stateKey]].pop());
      });
      var sortData = []; //lastItem.sort((key1, key2) => key1.median - key2.median);
      sortData1.forEach(function (el, index) {
        var data = lastItem.find((e) => e.state.trim() == el.state.trim());
        sortData.push(data);
      });

      self.rtBarChart.chartData.labels = sortData.map(
        (d) =>
          d.state +
          "~" +
          d.median.toFixed(2) +
          "~" +
          d.lower_90 +
          "~" +
          d.upper_90
      );
      var data = sortData.map((d) => (d.median < 0 ? 0 : d.median));
      var colors1 = [];
      var colors2 = [];
      data.forEach(function (value, index) {
        colors1[index] = self.getGreenToRed(value, 0.7);
        colors2[index] = self.getGreenToRed(value, 1);
      });
      var lower_90 = sortData.map((d) => (d.lower_90 < 0 ? 0 : d.lower_90));
      var upper_90 = sortData.map((d) => (d.upper_90 < 0 ? 0 : d.upper_90));

      var lower_50 = sortData.map((d) => (d.lower_50 < 0 ? 0 : d.lower_50));
      var upper_50 = sortData.map((d) => (d.upper_50 < 0 ? 0 : d.upper_50));

      var values1 = lower_90.map(function (v, i) {
        return [v, upper_90[i]];
      });
      var values2 = lower_50.map(function (v, i) {
        return [v, upper_50[i]];
      });
      var bubble = self.getBubbleData(sortData);

      self.rtBarChart.chartData.datasets.push(
        {
          type: "bubble",
          data: bubble,
          fill: true,
          backgroundColor: "white",
          borderWidth: 2,
          borderColor: "rgb(220,220,220)",
          order: 1,
          datalabels: {
            font: {
              size: 9,
            },
          },
        },
        {
          label: "50%",
          backgroundColor: colors2,
          data: values2,
          order: 2,
          datalabels: {
            labels: {
              title: null,
            },
          },
        },
        {
          label: "90%",
          backgroundColor: colors1,
          data: values1,
          order: 3,
          datalabels: {
            labels: {
              title: null,
            },
          },
        }
      );
    },
    getGreenToRed(value, opacity) {
      if (value.toFixed(2) >= 1.0) {
        return "rgba(255,0,0," + opacity + ")";
      } else if (value.toFixed(2) < 1.0) {
        return "rgba(0,255,0," + opacity + ")";
      }
      return "rgba(255,255,0," + opacity + ")";
    },
    numberFormatter(num) {
      if (typeof num === "string" || num instanceof String) {
        return num;
      }
      if (num >= 1000000000) {
        return (num / 1000000000).toFixed(2).replace(/\.0$/, "") + "G";
      }
      if (num >= 1000000) {
        return (num / 1000000).toFixed(2).replace(/\.0$/, "") + "M";
      }
      if (num >= 1000) {
        return (num / 1000).toFixed(2).replace(/\.0$/, "") + "K";
      }
      return num;
    },
    changeRtByStateSelect() {
      this.renderRtByStateChartData();
    },
    renderRtByStateChartData() {
      //TODO
      var self = this;
      if (self.originalJHUData.length === 0 || self.originalRTData.length === 0)
        return;

      self.rtChart.chartData.labels = [];
      self.rtChart.chartData.datasets = [];
      self.rtChart.extraOptions = {};
      self.rtChart.extraOptions = chartConfigs.rtLineChartOptions;
      var filterdataJHU = [...self.originalJHUData].filter(function (item) {
        return self.rtStates == item.state;
      });
      var filterdataRt = [...self.originalRTData].filter(function (item) {
        return self.rtStates == item.state;
      });
      var dates = self.getAllDates([...self.originalJHUData]);
      var allDate = [...new Set(dates)];
      var groupJHUStateData = lodash.groupBy(filterdataJHU, "state");
      var groupRtStateData = lodash.groupBy(filterdataRt, "state");
      Object.keys(groupRtStateData).forEach(function (stateKey, index) {
        var allPointData = self.generateChartPointData(
          groupJHUStateData[stateKey],
          allDate,
          "confirmed_daily"
        );
        var allRtData = self.generateChartPointData(
          groupRtStateData[stateKey],
          allDate,
          "median"
        );
        var colors2 = [];
        allRtData.forEach(function (value, index) {
          if (value.y >= 1) {
            colors2[index] = "rgba(255,0,0,1)";
          } else {
            colors2[index] = "rgba(0,255,0,1)";
          }
        });
        self.rtChart.chartData.datasets.push(
          {
            yAxisID: "positive",
            type: "bar",
            label: stateKey,
            data: allPointData,
            order: 2,
            backgroundColor: chartConfigs.colorOptions.color[stateKey.trim()],
            barThickness: 4,
          },
          {
            yAxisID: "rt",
            label: stateKey,
            data: allRtData,
            order: 1,
            pointBackgroundColor: colors2,
            borderColor: "rgb(255,255,255,0.7)",
            pointHoverBackgroundColor: colors2,
            pointRadius: 0,
            pointHoverRadius: 6,
            colors: colors2,
          }
        );
      });
    },
    chartOptionVaccin(labelString, index = 0) {
      var extraoption = {
        display: true,
        scaleLabel: {
          display: true,
          labelString: labelString,
        },
      };
      return [
        {
          ...extraoption,
          ticks: {
            beginAtZero: true,
            callback: function (value, index, values) {
              return parseInt(value)
                .toString()
                .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
            },
          },
        },
      ];
    },
    changeVaccinSelect() {
      this.renderVaccinChartData(this.vaccinChart.activeIndex);
    },
    renderVaccinChartData(index) {
      var self = this;
      self.vaccinChart.activeIndex = index;
      self.vaccinChart.chartData.labels = [];
      self.vaccinChart.chartData.datasets = [];
      self.vaccinChart.extraOptions = {};
      self.vaccinChart.extraOptions = lodash.cloneDeep(options);
      self.vaccinChart.extraOptions.scales.yAxes = self.chartOptionVaccin(
        "Vaccines",
        index
      );
      var key = "vaccines_distributed";
      if (index === 1) {
        key = "vaccinations_initiated";
      } else if (index === 2) {
        key = "vaccinations_completed";
      }
      var filterdata = [...self.originalVaccinData]
        .filter(function (item) {
          return self.vaccinStates.includes(item.state);
        })
        .sort(function (a, b) {
          return (
            self.vaccinStates.indexOf(a.state) -
            self.vaccinStates.indexOf(b.state)
          );
        });
      self.getChartDataSet(
        self.vaccinChart.chartData.datasets,
        filterdata,
        key,
        index,
        [...self.originalVaccinData]
      );
    },
  },
  mounted() {
    var self = this;
    window.addEventListener("resize", function () {
      self.generateRTChart();
    });
    window.onscroll = function () {
      self.scrollpage();
    };
    this.i18n = this.$i18n;
    if (this.enableRTL) {
      this.i18n.locale = "ar";
      this.$rtl.enableRTL();
    }
    this.getDashData();
    this.generateVaccinChart();
    //this.generateCovidActNowChart();
    this.generateJHUChart();
    this.generateRTChart();
  },
  beforeDestroy() {
    if (this.$rtl.isRTL) {
      this.i18n.locale = "en";
      this.$rtl.disableRTL();
    }
  },
};
</script>
<style>
.chart-area {
  min-height: 400px !important;
}
.title-lg {
  font-size: 1.8rem;
}
.title-sm {
  font-size: 1.0625rem;
}
.info-cursor {
  cursor: pointer;
}
@media (min-width: 320px) and (max-width: 768px) {
  .btn-group {
    display: block;
  }
}
.text-group {
  display: inline;
  position: absolute;
  bottom: 11px;
}
.title-sm {
  font-size: 0.9rem;
}
.title-lg {
  font-size: 1.9rem;
}
.fa-2x {
  font-size: 1.3em !important;
}
/* basic positioning */
.legend {
  margin-top: 20px;
  margin-left: 38px;
  list-style: none;
  font-weight: 100;
  font-size: 12px;
  line-height: 1.8;
}
.legend li {
  float: left;
  margin-right: 10px;
  color: #babac0;
}
.legend span {
  float: left;
  width: 17px;
  height: 17px;
  margin: 2px 5px;
  border-radius: 100px;
}
/* your colors */
.legend .fifty {
  background-color: rgba(0, 255, 0, 1);
}
.legend .ninety {
  background-color: rgba(0, 255, 0, 0.7);
}
.chartWrapper {
  position: relative;
}
.chartWrapper canvas {
  /*   position: absolute;
  left: 0;
  top: 0;
  pointer-events: none; */
}
.chartAreaWrapper {
  width: 600px;
  overflow-x: scroll;
}

.el-tooltip__popper.is-dark {
  width: 300px;
  text-align: center;
}
#chartjs-tooltip {
  width: 120px;
  font-size: 12px;
  opacity: 1;
  position: fixed;
  z-index: 9;
  background: rgba(255, 255, 255, 1);
  color: #000;
  border-radius: 3px;
  -webkit-transition: all 0.1s ease;
  transition: all 0.1s ease;
  pointer-events: none;
  -webkit-transform: translate(-50%, 0);
  transform: translate(-50%, 0);
}
#chartjs-tooltip:after {
  content: "";
  border-top: 5px solid #fff;
  border-right: 5px solid transparent;
  border-left: 5px solid transparent;
  bottom: 100%;
  position: absolute;
  bottom: -5px;
  left: 50%;
  transform: translateX(-50%);
}
@media (max-width: 1440px) and (min-width: 800px) {
  h2,
  .h2 {
    font-size: 1.1rem;
  }
  .title-lg {
    font-size: 1.5rem !important;
  }
}
@media (max-width: 1440px) and (min-width: 1280px) {
  .card .card-title {
    margin-bottom: 1rem !important;
  }
}
.col-2dot4,
.col-sm-2dot4,
.col-md-2dot4,
.col-lg-2dot4,
.col-xl-2dot4 {
  position: relative;
  width: 100%;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
}
.col-2dot4 {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 20%;
  flex: 0 0 20%;
  max-width: 20%;
}
@media (min-width: 540px) {
  .col-sm-2dot4 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 20%;
    flex: 0 0 20%;
    max-width: 20%;
  }
}
@media (min-width: 720px) {
  .col-md-2dot4 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 20%;
    flex: 0 0 20%;
    max-width: 20%;
  }
}
@media (min-width: 960px) {
  .col-lg-2dot4 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 20%;
    flex: 0 0 20%;
    max-width: 20%;
    padding-right: 5px;
    padding-left: 5px;
  }
}
@media (min-width: 1140px) {
  .col-xl-2dot4 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 20%;
    flex: 0 0 20%;
    max-width: 20%;
  }
}
</style>
